var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "pull-refresh",
        {
          on: { refresh: _vm.refreshList },
          model: {
            value: _vm.pullLoading,
            callback: function ($$v) {
              _vm.pullLoading = $$v
            },
            expression: "pullLoading",
          },
        },
        [
          _c(
            "list",
            {
              attrs: {
                finished: !_vm.hasNext,
                "finished-text": "没有更多了",
                "immediate-check": false,
              },
              on: { load: _vm.loadList },
              model: {
                value: _vm.loading,
                callback: function ($$v) {
                  _vm.loading = $$v
                },
                expression: "loading",
              },
            },
            [
              _vm.listInfo.length == 0 && !_vm.loading
                ? _c("div", {
                    staticStyle: { "text-align": "center", padding: "10vh 0" },
                  })
                : _vm._e(),
              _c(
                "div",
                { staticClass: "common-list" },
                _vm._l(_vm.listInfo, function (item, index) {
                  return _c("div", { key: index, staticClass: "common-item" }, [
                    _c("div", { staticClass: "common-content" }, [
                      _c(
                        "div",
                        { staticClass: "common-image" },
                        [
                          _c("van-image", {
                            staticClass: "common-avatar",
                            attrs: {
                              fit: "cover",
                              src: item.avatar || _vm.avatar,
                            },
                          }),
                        ],
                        1
                      ),
                      _c("div", { staticClass: "common-info" }, [
                        _c("h3", { staticClass: "common-name" }, [
                          _vm._v(_vm._s(item.salesName)),
                        ]),
                        _c("p", { staticClass: "clinic-name" }, [
                          _vm._v(_vm._s(item.stock)),
                        ]),
                      ]),
                    ]),
                    _c("div", { staticClass: "report-info report-foot" }, [
                      _c("span", { staticClass: "patient-name" }),
                      _c("span", { staticClass: "report-time" }, [
                        _c(
                          "span",
                          {
                            staticClass: "foot-btn replace-btn",
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                                return _vm.toSalesDeviceList(item)
                              },
                            },
                          },
                          [_vm._v("查看设备")]
                        ),
                      ]),
                    ]),
                  ])
                }),
                0
              ),
            ]
          ),
        ],
        1
      ),
      _vm.fieldPromptModel.show
        ? _c("fieldPrompt", {
            attrs: {
              title: "调仓出库",
              show: _vm.fieldPromptModel.show,
              fieldForm: _vm.fieldPromptModel.fieldForm,
              info: _vm.fieldPromptModel.info,
            },
            on: {
              "update:show": function ($event) {
                return _vm.$set(_vm.fieldPromptModel, "show", $event)
              },
              emit: _vm.fieldPromptEmit,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }